function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useBreakpoint } from "../components/BreakpointProvider";
function getResponsiveValue(value) {
  var breakpoint = useBreakpoint();
  if (breakpoint && value && _typeof(value) === 'object') {
    var responsiveValue = value;
    switch (breakpoint) {
      case 'xl':
        return responsiveValue.xl || responsiveValue.lg || responsiveValue.md || responsiveValue.sm || responsiveValue.xs;
      case 'lg':
        return responsiveValue.lg || responsiveValue.md || responsiveValue.sm || responsiveValue.xs;
      case 'md':
        return responsiveValue.md || responsiveValue.sm || responsiveValue.xs;
      case 'sm':
        return responsiveValue.sm || responsiveValue.xs;
      default:
        return responsiveValue.xs;
    }
  }
  return value;
}
export default getResponsiveValue;